import Colors from "./colors/Colors.palette";
import { ITheme } from "./theme.types";
import { fontSizes, fontFamilies } from "./typography/font-sizes";
import { breakpoints } from "./layout/breakpoints";
import {
  getFontThemeSize,
  increaseFontSize,
  decreaseFontSize,
} from "./utils/Font.utils";

import { getThemeBreakpoint } from "./utils/Breakpoint.utils";
import { layoutProperties } from "./layout/properties";
import {
  isEdge,
  isFirefox,
  isMobile,
  isSamsungBrowser,
  isMobileSafari,
} from "react-device-detect";

const CE_THEME: ITheme = {
  namespace: "ce-soar",
  colors: {
    alerts: Colors.Alerts,
    brand: Colors.Brand,
    cta: Colors.CTA,
    grays: Colors.Grays,
    essential: Colors.Essential,
    mapMarkers: Colors.MapMarkers,
  },
  breakpoints,
  fontSizes,
  fontFamilies,
  layoutProperties: {
    ...layoutProperties,
  },
  utils: {
    getFontThemeSize,
    increaseFontSize,
    decreaseFontSize,
    getThemeBreakpoint,
    browserUtils: {
      isEdge,
      isMobile,
      isFirefox,
      isSamsungBrowser,
      isMobileSafari,
    },
  },
};

export default { CE_THEME };
